import { ProjectUser } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateProjectUsersQuery } from "@/queries/query-project-users";

export function useAddUsersToProject(projectId: string) {
  const invalidateProjectUsersQuery = useInvalidateProjectUsersQuery();

  return useMutationWithErrorHandler(async (users: ProjectUser[]) => {
    await Promise.all(
      users.map(({ user, role }) =>
        getRanaApiV1().ProjectsApi.projectUserRoleUpdate({
          projectId,
          userId: user.id,
          projectUserUpdate: { role },
        })
      )
    );
    invalidateProjectUsersQuery();
  });
}
